// extracted by mini-css-extract-plugin
export var accordion = "_e0-0";
export var chevron = "_e0-3";
export var closed = "_e0-2";
export var content = "_e0-4";
export var open = "_e0-1";
export var rotate = "_e0-5";